/* WooCommerce Archive – Price ranges (chips + slider) autosubmit */
export function mount() {
  const $ = window.jQuery;
  if (!$) return;

  // Guard
  if (document.documentElement.dataset.wkArchivePriceFilter === '1') return;
  document.documentElement.dataset.wkArchivePriceFilter = '1';

  // Radiobuttons / checkboxes → min_price & max_price + submit
  $(document).on(
    'change',
    'form.wk-filter-form[data-autosubmit] input[name="price_range"], form.wk-filter-form[data-autosubmit] input[name="price_range[]"]',
    function () {
      const $form   = $(this).closest('form');
      const $radios = $form.find('input[name="price_range"]');
      const $checks = $form.find('input[name="price_range[]"]');

      let min = null, max = null;

      if ($radios.length) {
        const $r = $radios.filter(':checked');
        if ($r.length) {
          const [a, b] = String($r.val()).split('-');
          min = a === '' ? null : Number(a);
          max = b === '' ? null : Number(b);
        }
      } else if ($checks.length) {
        const vals = $checks.filter(':checked').map((_, el) => String(el.value)).get();
        vals.forEach(v => {
          const [a, b] = v.split('-');
          if (a !== '') min = (min === null) ? Number(a) : Math.min(min, Number(a));
          if (b !== '') max = (max === null) ? Number(b) : Math.max(max, Number(b));
        });
      }

      // Reset & set echte Woo min/max params
      $form.find('input[name="min_price"], input[name="max_price"]').remove();
      if (min !== null) $('<input>', { type:'hidden', name:'min_price', value:String(min) }).appendTo($form);
      if (max !== null) $('<input>', { type:'hidden', name:'max_price', value:String(max) }).appendTo($form);

      $form.trigger('submit');
    }
  );

  // Native Woo slider → autosubmit
  $(document.body).on('price_slider_change price_slider_updated', function () {
    const $wrap = $('.widget_price_filter .price_slider_amount');
    const $btn  = $wrap.find('button, input[type="submit"]');
    if ($btn.length) $btn[0].click();
  });
}
